fx.ns("desktop.common.panels", class ChangeThematicsPanel extends fx.components.PopupPanel {    
	constructor(data)
	{
		super(data);
		this.destroyOnSwitch = true;
	}

	create()
	{
		super.create();

		this.title = new fx.components.Text({text :fx.text("Sélectionnez la thématique"), className : "title center"});
		
		// Thematics list
		let box = new fx.components.Box();
		box.addChild(this.title, {width:"100%", height : 40, top : 0, left : "center"});
		this.containerCategories = new fx.components.HBox();
		for (let i = 0; i < this.data.themetags.length; i++)
		{
			let renderer = new shared.renderers.ThemeTagRenderer(this.data.themetags.getItemAt(i));
				 renderer.css("backgroundColor", this.data.themetags.getItemAt(i).background_color);
				 this.containerCategories.addChild( renderer, {width : 260, height : 55});
		}
		box.addChild(this.containerCategories, {width:"100%", height : 200, top : 80, left : "center"});
		this.addChild(box, { width : 870, height : 525, top : "center", left : "center"});
	}

    onReady()
    {
        super.onReady();
		this.on("click", this._onClick, this.containerCategories);
    }
	
	// go to Change themes view on thematic click
    _onClick(event)
    {
		let target = this.getChildFromUI(fx.dom.parent(event.target, ".ThemeTagRenderer"));
		if(target)
		{
			this.loading(true, fx.text("Chargement"));
			this.theme_tag_id = target.data.id;
			this.data.themes.load( this.theme_tag_id, true ); 
		}
    }

	onDataEvent(event)
	{
		if (event.type == "themes-loaded")
		{
			this.data.event("theme-tag-updated",this.theme_tag_id); 
			this.close();
		}
		
	}
	
});
